import { attr } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type ExamTypeStringEnum = "mammography" | "mri";

export default class MammographyDeclaredJournalEvent extends JournalEvent {
  static override type = "mammography-declared-journal-event";

  @attr("string") declare examType: ExamTypeStringEnum;

  @attr("number") declare acrScore: number;

  static override validations(intl: IntlService) {
    return {
      acrScore: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.mammography-declared-journal-event.acr-score"
          )
        }),
        validateNumber({
          integer: true,
          description: intl.t(
            "validations.mammography-declared-journal-event.acr-score"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.mammography-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      examType: validateInclusion({
        list: ["mammography", "mri"],
        allowBlank: true,
        description: intl.t(
          "validations.mammography-declared-journal-event.exam-type"
        )
      })
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "mammography-declared-journal-event": MammographyDeclaredJournalEvent;
  }
}
